module.exports = __webpack_public_path__ + "static/Polylang1-285c7afd3978d1326c3a21bce208e0ea.jpg";